//import Accordion from "@bsw/nightingale";
import React, { useState, useEffect } from 'react';
import { AccordionItem, Divider } from '../../index'
import './accordion.scss';

export const Accordion = ({
    accordionItems,
    borderStyle = "all",
    padding = "default",
    children,
    openIndex,
    showArrow = true,
    toggle = () => { },
}) => {

    const isOpen = (index) => {
        if (openIndex !== "" || openIndex !== undefined) {
            return openIndex === index;
        } else {
            return false;
        }
    }

    const accordionClasses = [
        `bsw-accordion`,
        `bsw-accordion__border-${borderStyle}`,
        `bsw-accordion__padding-${padding}`,
    ].join(' ');

    return <div className={accordionClasses} role="list">
        {children
            ? <>
                {children}
            </>
            : <>
                {accordionItems && accordionItems.map((item, index) => {
                    return <React.Fragment key={index}>
                        <AccordionItem
                            data-key={index}
                            disabled={item?.disabled}
                            headerAs={item?.headerAs}
                            heading={item?.heading}
                            className={item?.className}
                            content={item?.content}
                            open={isOpen(`${index}`)}
                            showArrow={showArrow}
                            toggle={(e) => toggle(e, `${index}`)}
                        />
                        {borderStyle === "none" && (index < accordionItems.length - 1) && <Divider mLeft="none" mRight="none" />}
                     </React.Fragment>
                })}
            </>
        }
    </div>;
}